import { render, staticRenderFns } from "./ContributionModal.vue?vue&type=template&id=59c2a93c&scoped=true&"
import script from "./ContributionModal.vue?vue&type=script&lang=js&"
export * from "./ContributionModal.vue?vue&type=script&lang=js&"
import style0 from "./ContributionModal.vue?vue&type=style&index=0&id=59c2a93c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c2a93c",
  null
  
)

export default component.exports